/** Format ERD: PLN-{KTC}-{YYYYMMDD}-{NN} */
export function buildPlanCode(kitchenCode: string, planDate: string, planSeq = 1): string {
  const dateTag = planDate.replace(/-/g, '')
  return `PLN-${kitchenCode}-${dateTag}-${String(planSeq).padStart(2, '0')}`
}

/** @deprecated use buildPlanCode */
export function buildPlanCodeFallback(planDate: string, kitchenCode = 'KIT', planSeq = 1): string {
  return buildPlanCode(kitchenCode, planDate, planSeq)
}

/** Format ERD: PRD-{KTC}-{YYYYMMDD}-{SEQ} */
export function buildProductionRefPrefix(planDate: string, kitchenCode = 'KIT'): string {
  const dateTag = planDate.replace(/-/g, '')
  return `PRD-${kitchenCode}-${dateTag}-`
}
